export const notificationSettingsUrl = 'notification-settings/';
export const liveStatusSettingsUrl = 'live-status-settings/';
